import React, { useEffect, useState } from "react";
import { DateRangeBarChart } from "../../Component/Analytics/DateRangeBarChart";
import AnalyticsDataService from "../../services/analytics";
import {
  Box,
  Button,
  Heading,
  Select,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";

import { getFYMonths } from "../../helper/helper";
import { DateTime } from "luxon";

export const ExpertRecords = () => {
  const [viewMode, setViewMode] = useState("currentWeek");

  const [recordType, setRecordType] = useState("peakHoursCount");

  const [countData, setCountData] = useState<any>([]);

  //   const calculateSumAfterRemovingLastN = (arr: any[]) => {
  //     // const modifiedArray = n > 0 ? arr.slice(0, -n) : arr;

  //     const totalSum = arr.reduce((sum, obj) => {
  //       const expertTotal = (obj.Prakriti || 0) + (obj.Simran || 0);
  //       return sum + expertTotal;
  //     }, 0);

  //     return totalSum;
  //   };

  const fyMonths = getFYMonths();

  const fetchExpertRecords = () => {
    let startDate = "";
    let endDate = "";

    const today = new Date();

    if (viewMode === "currentMonth") {
      const monthDate = DateTime.now();
      startDate = monthDate.startOf("month").toISODate(); // first day
      endDate = monthDate.endOf("month").toISODate();
      console.log(startDate, endDate);
    } else if (viewMode === "currentWeek") {
      const dayOfWeek = today.getDay(); // 0 (Sun) - 6 (Sat)
      const diffToMonday =
        today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      const monday = new Date(today.setDate(diffToMonday));
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      startDate = monday.toISOString().slice(0, 10);
      endDate = sunday.toISOString().slice(0, 10);
      // console.log(startDate, endDate);
    } else {
      const monthDate = DateTime.fromFormat(viewMode, "yyyy-MM");
      if (monthDate.isValid) {
        const first = monthDate.startOf("month");
        const last = monthDate.endOf("month");
        startDate = first.toISODate();
        endDate = last.toISODate();

        // console.log(startDate, endDate);
      }
    }

    if (recordType === "peakHoursCount") {
      AnalyticsDataService.getExpertPeakHoursCount(startDate, endDate)
        .then((res: any) => {
          const data = res.data.map((expert: any) => {
            const obj: any = {
              expertName: expert.full_name,
              expertPic: expert.photograph_link,
            };

            expert.hourlyBookings.forEach((hb: any) => {
              obj[`${hb.hour} Hours`] = hb.bookings;
            });

            return obj;
          });

          setCountData(data);
        })
        .catch((e: any) => {
          console.log(e);
        });
    } else if (recordType === "profileVisitCount") {
      AnalyticsDataService.getExpertProfileVisitCount(startDate, endDate)
        .then((res: any) => {
          const data = res.data.map((item: any) => {
            return {
              count: item.count,
              expertName: item.full_name,
              expertPic: item.photograph,
            };
          });
          setCountData(data);
        })
        .catch((e: any) => {
          console.log(e);
        });
    } else if (recordType === "slotCheckedCount") {
      AnalyticsDataService.getExpertSlotCheckedCount(startDate, endDate)
        .then((res: any) => {
          const data = res.data.map((item: any) => {
            return {
              count: item.count,
              expertName: item.full_name,
              expertPic: item.photograph,
            };
          });
          setCountData(data);
        })
        .catch((e: any) => {
          console.log(e);
        });
    } else if (recordType === "subsLeftCount") {
      AnalyticsDataService.getExpertSubsLeftCount()
        .then((res: any) => {
          const data = res.data.map((item: any) => {
            return {
              count: item.count,
              expertName: item.full_name,
              expertPic: item.photograph,
            };
          });
          setCountData(data);
        })
        .catch((e: any) => {
          console.log(e);
        });
    } else {
      AnalyticsDataService.getExpertBookingsCount(startDate, endDate)
        .then((res: any) => {
          const data = res.data.map((item: any) => {
            return {
              count: item.count,
              single: item.singleSessionCount,
              used_subscription: item.subscriptionSessionUsedCount,
              expertName: item.full_name,
              expertPic: item.photograph,
            };
          });
          setCountData(data);
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  };

  useEffect(() => {
    fetchExpertRecords();
  }, [viewMode, recordType]);

  return (
    <>
      <Box
        bg="#e98b90"
        color="white"
        fontWeight="bold"
        textAlign="center"
        textColor="black"
        py={4}
        px={6}
      >
        App Therapists
      </Box>
      <Box p={6} maxW="100%" bg="gray.50">
        <VStack align="start" spacing={4}>
          <HStack spacing={4} align="center">
            <Select
              w="235px"
              value={recordType}
              onChange={(e) => setRecordType(e.target.value)}
            >
              <option value="peakHoursCount">Peak Hours</option>
              <option value="profileVisitCount">Profile Visits</option>
              <option value="slotCheckedCount">Slot Checked</option>
              <option value="sessionsCount">Sessions</option>
              <option value="subsLeftCount">Remaining Subscriptions</option>
            </Select>

            {recordType !== "subsLeftCount" && (
              <Select
                w="200px"
                value={viewMode}
                onChange={(e) => setViewMode(e.target.value)}
              >
                <option value="currentWeek">Current Week</option>
                {/* <option value="currentMonth">Current Month</option> */}

                <optgroup label="FY 2025-2026">
                  {fyMonths.map((m, index) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </optgroup>
              </Select>
            )}
          </HStack>

          {/* <Text fontSize="lg" fontWeight="semibold">
            {viewMode === "currentMonth"
              ? "Current Month Report"
              : viewMode === "lastMonth"
              ? "Last Month Report"
              : "Current Week Report"}
          </Text> */}

          <Box w="100%" mt={6}>
            {countData.length > 0 && (
              <DateRangeBarChart
                data={countData}
                xKey="expertName"
                barKey="count"
                isSessionCount={recordType === "sessionsCount"}
                isPeakHoursCount={recordType === "peakHoursCount"}
              />
            )}
          </Box>
        </VStack>
      </Box>
    </>
  );
};
